import { PROFILE_SHOW_SELECTOR, PROFILE_HIDE_SELECTOR } from '../constants'

const appInitialState = {
    open: false,
    server: '',
    user: '',
    title: '',
}

export default function profile(state = appInitialState, action) {
    switch (action.type) {
        case PROFILE_SHOW_SELECTOR: {
            return {
                open: true,
                server: action.payload.server,
                user: action.payload.user,
                boundingRectangle: action.payload.boundingRectangle,
                title: action.payload.title,
            }
        }

        case PROFILE_HIDE_SELECTOR: {
            return {
                open: false,
                server: '',
                user: '',
                boundingRectangle: null,
                title: '',
            }
        }

        // Do nothing
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/profile.js